import React, { useState } from "react"
import { Modal, ModalBody, Spinner } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../../hooks/useAuth"
import { fetchCurrentSubscription } from "../../store/subscription/actions"
import { acknowledgeFreeFallbackNotice } from "../../api/requests/subscription-requests"

const NAVY = "#221C5D"

/**
 * Ücretli paketi biten ve Ücretsiz pakete düşen firmanın adminine bir kez gösterilir.
 * Hangi seçenek seçilirse seçilsin bildirim backend'de kapatılır.
 */
const FreePlanFallbackModal = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { roles } = useAuth()
  const { currentStatus } = useSelector((state) => state.subscription)
  const [closing, setClosing] = useState(false)

  const fromPlan = currentStatus?.freeFallbackFromPlanName
  if (!fromPlan || currentStatus?.impersonating || !roles.includes("ROLE_COMPANY_ADMIN")) return null

  const close = async (path) => {
    setClosing(true)
    try {
      await acknowledgeFreeFallbackNotice()
    } catch (e) {
      // Kapatma kaydedilemese de kullanıcı engellenmez; bildirim bir sonraki girişte yeniden çıkar.
    }
    dispatch(fetchCurrentSubscription())
    setClosing(false)
    if (path) navigate(path)
  }

  return (
    <Modal isOpen centered backdrop="static" keyboard={false}>
      <ModalBody className="text-center px-4 py-4">
        <div className="mb-3">
          <i className="bx bx-package" style={{ fontSize: 56, color: NAVY }} />
        </div>

        <h5 className="fw-bold mb-2" style={{ color: "#333" }}>
          {fromPlan} paketinizin süresi doldu
        </h5>
        <p className="text-muted mb-4" style={{ fontSize: 15 }}>
          Hesabınız <strong>{currentStatus.planName}</strong> pakete geçirildi. Verileriniz korunuyor;
          bundan sonra {currentStatus.planName} paketin özellikleri ve sınırları geçerli olacak.
        </p>

        <button
          className="btn btn-lg w-100 mb-2"
          style={{ backgroundColor: NAVY, borderColor: NAVY, color: "#fff", borderRadius: 999, fontWeight: 600 }}
          onClick={() => close("/subscription/plans")}
          disabled={closing}
        >
          <i className="bx bx-cart me-2" />
          Paket Satın Al
        </button>
        <button
          className="btn btn-lg btn-outline-secondary w-100"
          style={{ borderRadius: 999, fontWeight: 600 }}
          onClick={() => close()}
          disabled={closing}
        >
          {closing ? <Spinner size="sm" /> : `${currentStatus.planName} ile Devam Et`}
        </button>
      </ModalBody>
    </Modal>
  )
}

export default FreePlanFallbackModal
